(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-custom-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var splideEl = document.querySelector('[id^="rp-splide-"]');
  if (!splideEl) {
    shortenTitles(document.querySelector('.rp-grid-wrap'));
    return;
  }

  /* Inline chevron SVGs — no sprite, no CSP issues */
  var SVG_PREV = '<svg class="rp-chevron" viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>';
  var SVG_NEXT = '<svg class="rp-chevron" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>';

  function injectArrowIcons(el) {
    var prev = el.querySelector('.splide__arrow--prev');
    var next = el.querySelector('.splide__arrow--next');
    if (prev) prev.insertAdjacentHTML('beforeend', SVG_PREV);
    if (next) next.insertAdjacentHTML('beforeend', SVG_NEXT);
  }

  /* Load Splide JS from CDN */
  var script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
  script.onload = function () { initSplide(splideEl); };
  document.head.appendChild(script);

  function initSplide(el) {
    var perPage = window.innerWidth <= 768 ? 2 : 5;

    var splide = new Splide(el, {
      type         : 'slide',    /* non-looping */
      perPage      : perPage,
      perMove      : 1,    /* move a full page at a time — last page flushes right edge */
      gap          : '16px',
      pagination   : false,      /* no dots */
      arrows       : true,
      drag         : true,
      snap         : true,
      speed        : 450,
      easing       : 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      flickPower   : 400,
      flickMaxPages: 1,
      focus        : 0,
      trimSpace    : 'move',     /* trims extra space so last page always aligns flush */
      breakpoints  : {
        768: { perPage: 2, perMove: 2, gap: '12px' },
        400: { perPage: 2, perMove: 2, gap: '10px' },
      },
    });

    splide.mount();

    /* Inject our own chevron icons after mount (arrows exist in DOM now) */
    injectArrowIcons(el);

    splide.on('ready', function () {
      shortenTitles(el);
    });

    splide.on('moved', function () {
      attachWishlist();
    });
  }

  function shortenTitles(root) {
    if (!root) return;
    setTimeout(function () {
      root.querySelectorAll('.product-block__title').forEach(function (titleEl) {
        var text = titleEl.innerText.trim();
        if (text.length > 28) {
          titleEl.setAttribute('title', text);
          titleEl.innerText = text.substring(0, 28) + '...';
        }
      });
    }, 400);
  }

  function attachWishlist() {
    if (window.frcp && frcp.wishlist && typeof frcp.wishlist.attachOnCollection === 'function') {
      frcp.wishlist.attachOnCollection();
    }
  }

  document.addEventListener('frcp.wishlist.initialize', function () { setTimeout(attachWishlist, 3000); });
  document.addEventListener('frcp.wishlist.installed',  function () { setTimeout(attachWishlist, 3000); });

  document.addEventListener('shopify:section:load', function (e) {
    var newEl = e.target.querySelector('[id^="rp-splide-"]');
    if (newEl && window.Splide) { initSplide(newEl); }
  });
})();

/* Grid mode title shortening */
(function () {
  var gridWrap = document.querySelector('.rp-grid-wrap.is-active');
  if (!gridWrap) return;
  setTimeout(function () {
    gridWrap.querySelectorAll('.product-block__title').forEach(function (el) {
      var text = el.innerText.trim();
      if (text.length > 28) {
        el.setAttribute('title', text);
        el.innerText = text.substring(0, 28) + '...';
      }
    });
  }, 400);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

// Shorten long product titles in related products
function shortenRelatedProductTitles() {
  // change selector if needed (example: .product-block__title)
  var titleElements = document.querySelectorAll('.related-products .product-block__title');

  titleElements.forEach(function(titleEl) {
    var fullText = titleEl.innerText.trim();
    if (fullText.length > 28) {
      titleEl.setAttribute("title", fullText); // optional tooltip
      titleEl.innerText = fullText.substring(0, 28) + "...";
    }
  });
}

// Delay function to ensure products are fully loaded
setTimeout(function() {
  shortenRelatedProductTitles();
}, 3000);

// frcp wishlist — fires when app is ready on page load
document.addEventListener("frcp.wishlist.initialize", function () {
  setTimeout(function () {
    if (window.frcp && frcp.wishlist && typeof frcp.wishlist.attachOnCollection === 'function') {
      frcp.wishlist.attachOnCollection();
    }
  }, 3000);
});

// frcp wishlist — also fires after install
document.addEventListener("frcp.wishlist.installed", function () {
  setTimeout(function () {
    if (window.frcp && frcp.wishlist && typeof frcp.wishlist.attachOnCollection === 'function') {
      frcp.wishlist.attachOnCollection();
    }
  }, 3000);
});


  } catch(e) { console.error(e); }
})();
})();
